import UploadFile from 'api/commons/UploadFile'

const massiveImport = (courseId, file) => {
  return UploadFile(
    file,
    `administration/monitoring/${courseId}/massive_manually_import`
  )
}
export default massiveImport
